// extracted by mini-css-extract-plugin
module.exports = {"page_loader":"page-loader_page_loader__iOe6U","spin":"page-loader_spin__tHJLi","heart-beat":"page-loader_heart-beat__9Wu4P"};